import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import ModalSave from "../../common/ModelSave";
import Select from "react-select";
import { CancelButton, SaveButton } from "../../common/Button";
import {
  Row,
  Col,
  Form,
  Modal,
  Container,
  InputGroup,
  Button,
} from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { Context } from "../../../utils/context";
import JoditEditor from "jodit-react";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClipLoader } from "react-spinners";
library.add(fas);

const PriceEditOffCanvance = (props) => {
  const {
    postData,
    getData,
    Select2Data,
    IMG_URL,
    getDimension,
    deleteData,
    isAllow,
  } = useContext(Context);

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [childSubCategories, setChildSubCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [taxTypes, setTaxTypes] = useState([]);
  const [taxPercentages, setPercentages] = useState([]);
  const [attributes, setAttribute] = useState([]);
  const [subAttributes, setSubAttribute] = useState([]);
  const id = props.show;
  const [role, setRole] = useState([]);
  const [data, setData] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setVariants] = useState([]);
  const [loader, setLoder] = useState(false);
  const [user, setUser] = useState({});
  const GetUserData = async () => {
    const response = await getData(`/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
  };
  useEffect(() => {
    GetUserData();
  }, []);

  useEffect(() => {
    if (user?.id === 1) {
      setIsDisabled(true);
    }
  }, [user]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    watch,
    setValue,
    reset,
  } = useForm();
  const imagesFile = watch("images");
  const imageFile = watch("image1");

  const { fields, append, remove } = useFieldArray({
    control,
    name: "variants",
  });

  const {
    fields: addonField,
    append: addonappend,
    remove: addonremove,
  } = useFieldArray({
    control,
    name: "add_on",
  });

  const [variantsError, setVariantsError] = useState("");

  useEffect(() => {
    register("variants", {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setVariantsError(isValid ? "" : "At least one variant is required");
        return isValid;
      },
    });
  }, [register]);

  const validateSellingPrice = (value, index) => {
    const mrpValue = parseFloat(getValues(`variants.${index}.mrp`));
    const sellingPrice = parseFloat(value);
    if (sellingPrice >= mrpValue) {
      return "Selling price must be less than MRP";
    }
    return true; // Validation passed
  };

  const watchedVariants = watch("variants");
  const watchedAddOns = watch("add_on");
  const onSubmit = async (data) => {
    try {
      setLoder(true);

      const DataToSend = new FormData();

      // Append variants
      const variants = [];
      data.variants.forEach((variant, index) => {
        variants.push({
          // attribute_id: variant.attribute_id?.value,
          // sub_attribute_id: variant.sub_attribute_id?.value,
          id: variant.id,
          variant_option_id: variant.variant_id,
          v_name: variant.v_name,
          unit: variant.unit,
          mrp: variant.mrp,
          sku: variant.sku,
          s_price: variant.s_price,
        });
      });

      DataToSend.append("variants", JSON.stringify(variants));

      const response = await postData(`/product/price-edit/${id}`, DataToSend);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
        setLoder(false);
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteImage = async (imageId) => {
    const confirmDelete = window.confirm(
      "This image will be permanently deleted. Are you sure?",
    );

    if (!confirmDelete) return;

    try {
      const response = await deleteData(`/product/product-image/${imageId}`);
      if (response.success) {
        console.log("Image deleted successfully");
      } else {
        console.error("Failed to delete image");
      }
      GetEditData();
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  const deleteAddOnImage = async (imageId) => {
    const confirmDelete = window.confirm(
      "This image will be permanently deleted. Are you sure?",
    );

    if (!confirmDelete) return;
    try {
      const response = await deleteData(`/product/addon-image/${imageId}`);
      if (response.success) {
        console.log("Image deleted successfully");
      } else {
        console.error("Failed to delete image");
      }
      GetEditData();
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  const GetAllCategory = async () => {
    const response = await getData("/allsellercategories");

    if (response?.success) {
      setCategories(await Select2Data(response?.data, "category_id"));
    }
  };

  const GetAllVariant_Category = async () => {
    const response = await getData("/allvariantcategory");

    if (response?.success) {
      setCountries(await Select2Data(response?.data, "variant_category_id"));
    }
  };

  const GetAllSubCategory = async (id) => {
    const response = await getData(`/allsubcategories/${id}`);

    if (response?.success) {
      setSubCategories(await Select2Data(response?.data, "sub_category_id"));
    }
  };

  const GetAllChildSubCategory = async (id) => {
    const response = await getData(`/allchildsubcategories/${id}`);

    if (response?.success) {
      setChildSubCategories(
        await Select2Data(response?.data, "child_sub_category_id"),
      );
    }
  };

  const GetAllBrands = async (user) => {
    const response = await getData(`/allbrands?user_id=${user?.id}`);

    if (response?.success) {
      setBrands(await Select2Data(response?.data, "brand_id"));
    }
  };
  const GetAllTaxTypes = async () => {
    const response = await getData("/all-tax-type");

    if (response?.success) {
      setTaxTypes(await Select2Data(response?.data, "tax_type_id"));
    }
  };

  const GetAllTaxPercentages = async (id) => {
    const response = await getData(`/all-tax-percentage/${id}`);

    if (response?.success) {
      setPercentages(await Select2Data(response?.data, "tax_percentage_id"));
    }
  };

  const GetAllAttributes = async () => {
    const response = await getData(`/all-attribute`);

    if (response?.success) {
      setAttribute(await Select2Data(response?.data, "attribute_id"));
    }
  };

  const GetAllSubAttributes = async (id) => {
    const response = await getData(`/all-sub-attribute/${id}`);

    if (response?.success) {
      setSubAttribute(await Select2Data(response?.data, "sub_attribute_id"));
    }
  };

  const GetAllVariants = async (id) => {
    const response = await getData(`/allvariant/${id}`);

    if (response?.success) {
      setVariants(await Select2Data(response?.data, "id", "name"));
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/product/${id}`);

    if (response?.success) {
      setData(response?.data);
      reset(response?.data);

      const variantCategoryId = response.data.variant_category_id?.value;

      if (variantCategoryId) {
        GetAllVariants(variantCategoryId);
      }
    }
    // setData(response);
  };

  useEffect(() => {
    GetEditData();
    GetAllCategory();
    // GetAllBrands();
    GetAllTaxTypes();
    GetAllAttributes();
    GetAllVariant_Category();
    // GetAllVariants();
  }, []);
  useEffect(() => {
    if (user) {
      GetAllBrands(user);
    }
  }, [user]);

  const handleRemoveVariant = async (index, variantId) => {
    // Remove the variant from the fields array

    remove(index);
    // try {
    // const vData = {
    //   variant_id: variantId,
    //   product_id: id
    // }
    // console.log(vData);
    // const response = await deleteData(`/product/delete-variant`, { vData });
    // if (response.success) {
    //   console.log("Image deleted successfully");
    // } else {
    //   console.error("Failed to delete image");
    // }
    // GetEditData();
    // } catch (error) {
    //   console.error("Error deleting image:", error);
    // }
  };
  const [preview, setPreview] = useState({});

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Edit Employee</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          {/* <Card className="shadow-lg p-3 mb-5 bg-white rounded"> */}
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Edit Product Price  : -{data?.name}</Card.Title>
              <hr />
              <Container>
                <Form
                  // onSubmit={() => handleSubmit(onSubmit)}
                  role="form"
                  // className="stateclass"
                >
                  <Row>
                    <div className="main-form-section mb-3"></div>
                    <Card.Title>
                      Product variants Details
                      {variantsError && (
                        <div className="text-danger">{variantsError}</div>
                      )}
                    </Card.Title>
                    <hr />

                    {fields.map((variant, index) => (
                      <div key={variant.id} className="main-form-section mb-3">
                        <Row>
                          <Col md={3}>
                            <div className="main-form-section mb-3">
                              <Row className="row justify-content-center mb-2">
                                <Form.Label>Variant</Form.Label>
                                <Controller
                                  name={`variants.${index}.variant_id`} // ← THIS IS THE KEY FIX
                                  control={control}
                                  rules={{
                                    required: "Please select a variant",
                                  }}
                                  render={({ field }) => (
                                    <Select
                                      {...field}
                                      options={states}
                                      value={
                                        states.find(
                                          (option) =>
                                            option.value === field.value,
                                        ) || null
                                      }
                                      onChange={(option) =>
                                        field.onChange(option?.value)
                                      }
                                      placeholder="Select Variant"
                                      isDisabled={isDisabled}
                                    />
                                  )}
                                />

                                {errors?.variants?.[index]?.variant_id && (
                                  <span className="text-danger">
                                    {errors.variants[index].variant_id.message}
                                  </span>
                                )}
                              </Row>
                            </div>
                          </Col>

                          <Col md={3}>
                            <div className="main-form-section mb-3">
                              <Row className="justify-content-center">
                                <Form.Label>Variant Name</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      disabled={isDisabled}
                                      type="text"
                                      name={`variants.${index}.v_name`} // Register color for the variant
                                      placeholder="Variant Name"
                                      className={classNames("", {
                                        "is-invalid":
                                          errors?.variants?.[index]?.v_name,
                                      })}
                                      {...register(`variants.${index}.v_name`, {
                                        required: "Variant name is required",
                                      })}
                                    />
                                  </InputGroup>

                                  {errors?.variants?.[index]?.v_name && (
                                    <span className="text-danger">
                                      {errors.variants[index].v_name.message}
                                    </span>
                                  )}
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col md={4}>
                            <div className="main-form-section mb-3">
                              <Row className="justify-content-center">
                                <Form.Label>Stock Unit</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      disabled={isDisabled}
                                      type="number"
                                      name={`variants.${index}.unit`}
                                      placeholder="Stock Unit"
                                      className={classNames("", {
                                        "is-invalid":
                                          errors?.variants?.[index]?.unit, // Updated error handling
                                      })}
                                      {...register(`variants.${index}.unit`, {
                                        required: "Stock Unit is required",
                                      })}
                                    />
                                  </InputGroup>
                                  {errors?.variants?.[index]?.unit && (
                                    <span className="text-danger">
                                      {errors?.variants?.[index]?.unit.message}
                                    </span>
                                  )}
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          {/* MRP */}
                          <Col md={4}>
                            <div className="main-form-section mb-3">
                              <Row className="justify-content-center">
                                <Form.Label>mrp</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      disabled={isDisabled}
                                      type="number"
                                      name={`variants.${index}.mrp`}
                                      placeholder="mrp"
                                      className={classNames("", {
                                        "is-invalid":
                                          errors?.variants?.[index]?.mrp, // Updated error handling
                                      })}
                                      {...register(`variants.${index}.mrp`, {
                                        required: "MRP is required",
                                      })}
                                    />
                                  </InputGroup>
                                  {errors?.variants?.[index]?.mrp && (
                                    <span className="text-danger">
                                      {errors.variants[index].mrp.message}
                                    </span>
                                  )}
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          {/* SKU */}
                          <Col md={4}>
                            <div className="main-form-section mb-3">
                              <Row className="justify-content-center">
                                <Form.Label>sku</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      disabled={isDisabled}
                                      type="text"
                                      name={`variants.${index}.sku`}
                                      placeholder="sku"
                                      className={classNames("", {
                                        "is-invalid":
                                          errors?.variants?.[index]?.sku, // Updated error handling
                                      })}
                                      {...register(`variants.${index}.sku`, {
                                        required: "sku is required",
                                      })}
                                    />
                                  </InputGroup>
                                  {errors?.variants?.[index]?.sku && (
                                    <span className="text-danger">
                                      {errors.variants[index].sku.message}
                                    </span>
                                  )}
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          {/* Selling Prise */}
                          <Col md={4}>
                            <div className="main-form-section mb-3">
                              <Row className="justify-content-center">
                                <Form.Label>Selling Price</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      disabled={isDisabled}
                                      type="number"
                                      name={`variants.${index}.s_price`}
                                      placeholder="Selling Price"
                                      className={classNames("", {
                                        "is-invalid":
                                          errors?.variants?.[index]?.s_price, // Updated error handling
                                      })}
                                      {...register(
                                        `variants.${index}.s_price`,
                                        {
                                          required: "Selling Price is required",
                                          validate: (value) => {
                                            if (!value)
                                              return "Selling Price is required";
                                            const minimumOrderValue =
                                              parseFloat(
                                                getValues(
                                                  `variants.${index}.mrp`,
                                                ),
                                              );
                                            if (parseFloat(value) <= 0) {
                                              return "Selling Price must be a positive number";
                                            }

                                            // Check if discount is less than minimum order value
                                            if (
                                              parseFloat(value) >
                                              minimumOrderValue
                                            ) {
                                              return "Selling Price must not be greater than MRP";
                                            }

                                            return true; // Return true for valid input
                                          },
                                        },
                                      )}
                                    />
                                  </InputGroup>
                                  {errors?.variants?.[index]?.s_price && (
                                    <span className="text-danger">
                                      {errors.variants[index].s_price.message}
                                    </span>
                                  )}
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                  
                        </Row>
                        {!isDisabled && (
                          <button
                            type="button"
                            className="add-varient"
                            onClick={() => remove(index)}
                          >
                            Remove Variant
                          </button>
                        )}
                      </div>
                    ))}
                    <div className="main-form-section mb-3"></div>
                    <hr />
                    {!isDisabled && (
                      <div className="text-center">
                        <button
                          type="button"
                          className="add-varient"
                          onClick={() => append({})}
                        >
                          + Add Variant
                        </button>
                      </div>
                    )}

                    <div className="mt-5 pb-3">
                      {!isDisabled && (
                        <div className="d-flex justify-content-center">
                          <Link>
                            <CancelButton
                              name={"cancel"}
                              handleClose={props.handleClose}
                            />
                          </Link>
                          {loader ? (
                            <>
                              <div className="text-center">
                                <ClipLoader />
                              </div>
                            </>
                          ) : (
                            <Button
                              name={"save"}
                              onClick={handleSubmit(onSubmit)}
                              type="button"
                              className="save-btnnnnnn"
                            >
                              <FontAwesomeIcon
                                icon="fa-solid fa-floppy-disk"
                                className="me-2"
                              />
                              save
                            </Button>
                          )}
                        </div>
                      )}
                      {isDisabled && (
                        <div className="d-flex justify-content-center">
                          <Link>
                            <CancelButton
                              name={"Back"}
                              handleClose={props.handleClose}
                            />
                          </Link>
                        </div>
                      )}
                    </div>
                  </Row>
                </Form>
              </Container>
            </Card.Body>
          </Card>
          {/* </Card> */}
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default PriceEditOffCanvance;
